export const viewMode = [
  {
    name: "Card",
    icon: "grid",
    mode: "card",
  },
  {
    name: "List",
    icon: "menu",
    mode: "list",
  },

  {
    name: "Cover",
    icon: "cover",
    mode: "cover",
  },
];
